import React, { useEffect } from 'react';
import { FaTimes, FaInfoCircle, FaFilePdf } from 'react-icons/fa';
import './NoPdfMessage.css';

const NoPdfMessage = ({ deviceName, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target.className === 'no-pdf-backdrop') {
      onClose();
    }
  };

  return (
    <div className="no-pdf-backdrop" onClick={handleBackdropClick}>
      <div className="no-pdf-container">
        <button className="no-pdf-close" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="no-pdf-content">
          <div className="no-pdf-icon">
            <FaFilePdf />
          </div>
          
          <h3 className="no-pdf-title">Manual em Breve</h3>
          
          <p className="no-pdf-message">
            O manual completo de instruções para o <strong>{deviceName}</strong> ainda não está disponível para visualização.
          </p>

          <div className="no-pdf-info">
            <FaInfoCircle className="info-icon" />
            <div>
              <h4>Documentação Disponível</h4>
              <p>
                Você pode encontrar informações sobre este dispositivo na documentação oficial do Traccar:
              </p>
              <a 
                href="https://www.traccar.org/devices/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="traccar-link"
              >
                Ver Documentação Traccar →
              </a>
            </div>
          </div>

          <div className="no-pdf-contact">
            <p>
              Para mais informações sobre este dispositivo, entre em contato conosco através do formulário.
            </p>
            <button 
              onClick={() => {
                onClose();
                setTimeout(() => {
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }, 300);
              }}
              className="contact-btn"
            >
              Falar com Especialista
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoPdfMessage;

